
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my",
      function () {
        return require("private-next-pages/my/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my"])
      });
    }
  